
/**
 * This method is used to check if a date is valid or invalid
 * @param {String} d This is the value which is to be checked, if it is a valid date
 * @returns {Boolean} True or False, depending on if the date is valid or invalid
 */
export const isValidDate = (d) => {
  return d instanceof Date && !isNaN(d);
}